import React from 'react';

import {useGetAutoDeliveryDetails} from '@/api/consumerApi';
import analyticsEventValues from '@/consts/analytics/analyticsEventValues';
import {
    AUTO_DELIVERY_VIEW_ORDER_LINK,
    AUTO_DELIVERY_VIEW_ORDER_LINK_ARIA_LABEL,
} from '@/consts/localization/localizationKeys';
import {PUSH_NOTIFICATIONS_PROMPT_TYPES} from '@/consts/pushNotifications/pushNotificationsPromptTypes';
import amplitudeAutodeliveryTracking from '@/services/analytics/amplitude/amplitudeAutoDeliveryTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {schedulePushPromptIfNeeded} from '@/services/pushNotification/pushNotificationPromptService';
import AutoDeliveryActiveProgress from '@/views/AutoDelivery/AutoDeliveryActive/AutoDeliveryActiveProgress';
import AutoDeliveryPaymentPendingButton from '@/views/AutoDelivery/AutoDeliveryPaymentPending/AutoDeliveryPaymentPendingButton';
import AutoDeliveryPaymentPendingTitle from '@/views/AutoDelivery/AutoDeliveryPaymentPending/AutoDeliveryPaymentPendingTitle';

import AutoDeliveryWidgetContainer from './components/AutoDeliveryWidgetContainer';
import AutoDeliveryWidgetHeader from './components/AutoDeliveryWidgetHeader';

const AutoDeliveryStatusPaymentPending = ({className}) => {
    const {
        data: {
            autoDelivery: {status},
        },
    } = useGetAutoDeliveryDetails();

    const amplitudeEvent = () => {
        schedulePushPromptIfNeeded(PUSH_NOTIFICATIONS_PROMPT_TYPES.AUTODELIVERY_DASHBOARD_CLICK);
        amplitudeAutodeliveryTracking.trackAutoDeliveryDashboardButtonClick(analyticsEventValues.CHECK_ORDER_STATUS);
        googleAnalyticsService.trackAutoDeliveryDashboardButtonClick(analyticsEventValues.CHECK_ORDER_STATUS);
    };

    return (
        <AutoDeliveryWidgetContainer className={className}>
            <AutoDeliveryWidgetHeader
                btnLocalizationKey={AUTO_DELIVERY_VIEW_ORDER_LINK}
                btnAriaLabelKey={AUTO_DELIVERY_VIEW_ORDER_LINK_ARIA_LABEL}
            />
            <AutoDeliveryWidgetContainer.ContentContainer>
                <AutoDeliveryPaymentPendingTitle className='mt-6 md:mt-0' />
                <AutoDeliveryActiveProgress status={status} className='mt-4 md:mt-8' />
                <AutoDeliveryPaymentPendingButton amplitudeEvent={amplitudeEvent} className='mt-8 md:w-auto' />
            </AutoDeliveryWidgetContainer.ContentContainer>
        </AutoDeliveryWidgetContainer>
    );
};

export default AutoDeliveryStatusPaymentPending;
